import {
  AudienceEstimateRequest,
  ReachActiveUrlResponse,
  ReachSuggestedTargetingUrlResponse,
  ReachTrafficAnalysis,
} from '@driftt/api-types'

import { ReachAPI } from 'api'

export const getEstimate = (payload: AudienceEstimateRequest) =>
  ReachAPI.post<ReachTrafficAnalysis>(`/estimate/v1`, payload)

export const fetchSiteTraffic = (filterUrl: string = '') => {
  const queryParam = filterUrl ? `?filterUrl=${filterUrl}` : ''
  return ReachAPI.get<ReachSuggestedTargetingUrlResponse>(
    `traffic/suggested_urls${queryParam}`
  )
}

export const fetchActiveUrls = (filterUrl: string = '') => {
  const queryParam = filterUrl ? `?filterUrl=${filterUrl}` : ''
  return ReachAPI.get<ReachActiveUrlResponse>(
    `traffic/active_urls?filterUrl=${queryParam}`
  )
}
